import React, { useState } from "react";

import insuranceImg from "../../assets/insurance.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaFileInvoiceDollar } from "react-icons/fa";

const styles = `
  /* ── HEADER ── */
  .ins-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .ins-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .ins-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .ins-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .ins-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .ins-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .ins-triangle-left {
    position: absolute;
    left: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .ins-triangle-right {
    position: absolute;
    right: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .ins-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .ins-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  /* ── MAIN ── */
  .ins-main {
    display: flex;
    align-items: center;
    padding: 60px 80px;
    gap: 60px;
  }

  .ins-image-wrap {
    flex: 1;
  }

  .ins-image-wrap img {
    width: 100%;
    max-width: 650px;
  }

  .ins-accordion {
    flex: 1.2;
  }

  .ins-accordion-item {
    margin-bottom: 18px;
  }

  .ins-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
  }

  .ins-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .ins-header {
      height: auto;
      min-height: 90px;
    }

    .ins-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .ins-header-title h2 {
      font-size: 22px;
    }

    .ins-triangle-left,
    .ins-triangle-right {
      width: 50px;
    }

    .ins-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .ins-header {
      flex-direction: column;
      height: auto;
    }

    .ins-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .ins-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .ins-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .ins-triangle-left,
    .ins-triangle-right {
      width: 40px;
    }

    .ins-header-title h2 {
      font-size: 18px;
    }

    .ins-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .ins-image-wrap {
      width: 100%;
      text-align: center;
    }

    .ins-image-wrap img {
      max-width: 100%;
    }

    .ins-accordion {
      width: 100%;
      flex: none;
    }

    .ins-accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .ins-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .ins-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .ins-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .ins-header-right {
      height: 60px;
    }

    .ins-header-title h2 {
      font-size: 15px;
    }

    .ins-triangle-left,
    .ins-triangle-right {
      width: 28px;
    }

    .ins-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .ins-accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .ins-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .ins-accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function InsurancePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Insurance price and guarantee",
      content:
        "AI helps insurers evaluate risk and determine pricing using historical and real-time data."
    },
    {
      title: "2.Reserve optimization of claims",
      content:
        "AI models help estimate future liabilities and optimize claim reserves."
    },
    {
      title: "3.Automatic check",
      content:
        "Automated verification improves underwriting and claim decisions."
    },
    {
      title: "4.Effective customer support",
      content:
        "AI chatbots reduce workload and improve response time."
    },
    {
      title: "5.Personalized recommendation systems",
      content:
        "AI suggests policies based on customer behavior and preferences."
    },
    {
      title: "6.Marketing and trend analysis",
      content:
        "AI identifies potential customers and improves targeting."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER */}
      <div className="ins-header">

        {/* LEFT */}
        <div
          className="ins-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="ins-header-overlay" />

          <div className="ins-header-badge">
            <div className="ins-header-icon-box">
              <FaRobot style={{ color: "#fff" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto", fontSize: "22px" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="ins-header-right">
          <div className="ins-triangle-left" />
          <div className="ins-triangle-right" />

          <div className="ins-header-title">
            <FaFileInvoiceDollar style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Insurance</h2>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="ins-main">

        {/* IMAGE */}
        <div className="ins-image-wrap">
          <img src={insuranceImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="ins-accordion">
          {data.map((item, i) => (
            <div key={i} className="ins-accordion-item">
              <div
                className="ins-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span style={{ fontSize: "22px" }}>
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="ins-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default InsurancePage;
